module.exports = "/_next/static/images/why-hardware-50b67e38dec0b5425a05d19415b0bbfd.jpg";